import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DIALOG_DATA } from '@angular/cdk/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { BaseModalContent } from '../base-modal-content';

@Component({
  selector: 'app-confirmation-message',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './confirmation-message.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmationMessageComponent extends BaseModalContent {
  constructor(
    @Inject(DIALOG_DATA)
    public data: {
      title?: string;
      bodyMessage?: string;
      htmlMessage?: string;
      buttons: {
        label: string;
        handler: () => void;
      }[];
    }
  ) {
    super();
  }
}
